import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../../assets/image.png";
import { EllipsisVertical, Trash2, Users } from "lucide-react";
import { useDispatch } from "react-redux";
import { updateRefreshDripCardsData } from "../../redux/dripData";
import apiServiceHandler from "../../service/apiService";
import "toastr/build/toastr.min.css";
import toastr from "toastr";

const DripCard = ({ card }) => {
  const navigate = useNavigate();
  const [openPopover, setOpenPopover] = useState(null);
  const dispatch = useDispatch()

  const togglePopover = (cardId) => {
    setOpenPopover(openPopover === cardId ? null : cardId);
  };

  const removeCampaign = async (id) => {
    try {
      const response = await apiServiceHandler(
        "DELETE",
        `api/drip-compaign/${id}`
      );
      if (response.status) {
        toastr.success(response?.message);
        dispatch(updateRefreshDripCardsData(true))
      }
    } catch (error) {
      console.error("Error removing campaign:", error);
    }
  };

  return (
    <div className="drip-card--content">
      <div className="card__wrapper">
        <div className="card-image">
          <img src={Logo} />
        </div>
        <div className="card__heading">
          <span className="jurni-font-roboto">{card?.title}</span>
        </div>
        <div className="card__content">
          <div className="card-meta-item">
            <div className="card-meta-item-icon"></div>
            <div className="card-meta-item-content"></div>
          </div>
          <div className="steps-info">
            <div className="icon-brand">
              <span className="icon--members">
                <svg
                  viewBox="0 0 20 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="icon__svg"
                  preserveAspectRatio="xMidYMid meet"
                  style={{ width: "20px", height: "20px" }}
                >
                  <path
                    d="M10 0a3 3 0 100 6 3 3 0 000-6zM3.5 1a2.5 2.5 0 100 5 2.5 2.5 0 000-5zm13 0a2.5 2.5 0 100 5 2.5 2.5 0 000-5zM10 18a4.505 4.505 0 01-4.5-4.5V8.75C5.5 7.785 6.285 7 7.25 7h5.5c.965 0 1.75.785 1.75 1.75v4.75c0 2.481-2.019 4.5-4.5 4.5zm-5.5-4.5V8.75c0-.664.237-1.274.63-1.75H1.75C.785 7 0 7.785 0 8.75V12a4.005 4.005 0 005.03 3.865l.01-.004A5.459 5.459 0 014.5 13.5zm11 0V8.75c0-.664-.237-1.274-.63-1.75h3.38c.965 0 1.75.785 1.75 1.75V12a4.005 4.005 0 01-5.03 3.865l-.01-.004c.342-.716.54-1.516.54-2.361z"
                    fill="#000"
                  ></path>
                </svg>
              </span>
            </div>
            <div className="step-text">
              <span>3 Steps</span>
            </div>
          </div>
          <div class="card-meta-item">
            <div class="card-meta-item-icon"></div>
            <div class="card-meta-item-content"></div>
          </div>
          <div className="steps-info">
            <div className="icon-members">
              <span class="icon--group ">
                <Users style={{ width: "20px", height: "20px" }} />
              </span>
            </div>
            <div className="trigger-text">
              <span>1 Trigger</span>
            </div>
          </div>
        </div>
        <div className="card__action-menu" onMouseLeave={() => setOpenPopover(null)}>
          <div className="dropdown-activator">
            <button className="btn-card-action" onClick={() => togglePopover(card?._id)}>
              <span className="icon--menu-dots">
                <EllipsisVertical />
              </span>
            </button>
            {openPopover === card?._id && (
              <div className="group-dropdown-popover">
                <div className="group-dropdown-content">
                  <div
                    className="group-menu-item"
                    style={{margin: '0', padding: '4px 16px'}}
                    onClick={() => removeCampaign(card?._id)}
                  >
                    <span className="icon__settings">
                      <Trash2
                        style={{
                          width: "20px",
                          height: "20px",
                          color: "#d1b794",
                        }}
                      />
                    </span>
                    <div className="group-menu-item__label">Remove</div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="card__action">
        <button
          className="courses-card__btn"
          onClick={() => navigate(`/campaigns/${card?._id}`)}
        >
          <span className="courses-card__btn">Visit</span>
        </button>
      </div>
    </div>
  );
};

export default DripCard;
